import * as firebase from "firebase/app"
import "firebase/storage"
import AppService from "./app-service"

const path = "customers"

export default class CustomerService extends AppService {

  constructor() {
    super({ path })
  }

  getCustomerLogo(customerId) {
    return this.http.get(`${path}/${customerId}/logo`) 
  }

  removeCustomerLogo(customerId, image) {
    return firebase.storage().ref(`${path}/${customerId}/logo`).child(image.name).delete()
  }

  checkCustomerName(name, shortName, id) {
    return this.http.post("check-customer-name", { name, shortName, id })
  }  
}